module.exports = __webpack_public_path__ + "static/media/youtubecolored.e6a5dd8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/youtubecolored.svg
// module id = 2073
// module chunks = 118